function indexLeaves(leaves) {
  const map = new Map();
  for (const d of leaves) {
    const key = d.token.toLowerCase();
    if (!map.has(key)) map.set(key, d);
  }
  for (const d of leaves) {
    (d.aliases || []).forEach((a) => {
      const k = String(a).toLowerCase();
      if (!map.has(k)) map.set(k, d);
    });
  }
  return map;
}

/**
 * @param {Array<{group:string, fields:object[]}>} groups
 * @returns {{ topLevel: Map, collections: Map }}
 */
export function buildIndex(groups) {
  const collections = new Map();
  const leaves = [];
  for (const g of groups || []) {
    for (const d of g.fields || []) {
      if (d.kind === 'collection') {
        collections.set(d.token.toLowerCase(), {
          ...d,
          itemsByToken: indexLeaves(d.itemFields || [])
        });
      } else {
        leaves.push(d);
      }
    }
  }
  return { topLevel: indexLeaves(leaves), collections };
}
